export default __webpack_public_path__ + "84e87913571b9b9e04f95146b4693b55.png";